module.exports = __webpack_public_path__ + "img/2025-11-17c_3.d8e9dd69.jpg";